import React, { useRef } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  CircularProgress,
  Typography,
} from "@mui/material";
import { getDisplayTime } from "../../util/formatting";
import { babyTrackerApi } from "../../data/babyTrackerApi";
import { useDispatch } from "react-redux";
import { dialogSlice } from "../../data/dialogSlice";
import { useNavigate } from "react-router-dom";
import useOnLongPress from "../../hooks/useOnLongPress";
import { Pump } from "../../api/tracker";

export default function PumpCard() {
  const { isLoading, isError, data } = babyTrackerApi.useGetAllPumpsQuery();
  const [deletePump] = babyTrackerApi.useDeletePumpMutation();
  const [updatePump] = babyTrackerApi.useUpdatePumpMutation();
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const cardRef = useRef<HTMLButtonElement>();
  useOnLongPress(cardRef, () => {
    navigate("/records/pumps");
  });

  if (isLoading) {
    return <CircularProgress />;
  }

  if (isError) {
    return <div>Failed to get last pump</div>;
  }

  const lastPump = data[0];
  if (!lastPump) {
    return null;
  }

  return (
    <Card>
      <CardActionArea
        ref={cardRef}
        data-long-press-delay="1000"
        onClick={() =>
          dispatch(
            dialogSlice.actions.openPumpDialog({
              title: "How did pumping go?",
              inputTitle: "Volume pumped? (ml)",
              valueKey: "pumpedMls",
              record: lastPump,
              onDelete: deletePump,
              onSave: ({ date, notes, value }) =>
                updatePump({
                  id: lastPump.id,
                  date: date.toISOString(),
                  notes,
                  pumpedMls: value,
                }),
            })
          )
        }
      >
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            Pump
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {getDisplayTime(lastPump.date)} {lastPump.pumpedMls}mls
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
